import { itemSelectors } from '../constants/archive-list-widget';

// todo - waiting for back end
export const createArchiveListController = ({ $w }) => ({
  pageReady: () => {
    $w(itemSelectors.MEDIA_BOX).show();
  },
});
